<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-card v-on:keyup.enter="buildNewSearch">
      <v-card-title>
        <h2>{{ onlyProjects ? "Projekty placówek" : "Wnioski placówek" }}</h2>
        <v-spacer></v-spacer>
      </v-card-title>

      <v-layout align-center justify-center row>
        <v-flex xs2>
          <v-text-field
            browser-autocomplete="off"
            class="ma-2"
            v-model="searchedFields.projectCode"
            :label="onlyProjects ? 'Nr projektu' : 'Nr wniosku'"
            aria-label="project code"
            for="all-agency-projects-list-project-code"
            id="all-agency-projects-list-project-code"
          ></v-text-field>
        </v-flex>
        <v-flex xs3>
          <v-autocomplete
            clearable
            class="ma-2"
            v-model="searchedFields.contestName"
            label="Nazwa naboru"
            :items="contestNameList"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs3>
          <v-autocomplete
            v-if="!onlyMine"
            class="ma-2"
            v-model="searchedFields.agencyId"
            :items="agencyList"
            item-text="name"
            item-value="id"
            label="Nazwa placówki"
            clearable
          ></v-autocomplete>
        </v-flex>
        <v-flex xs2>
          <v-autocomplete
            class="ma-2"
            v-model="searchedFields.projectStatus"
            :items="onlyProjects ? statusListOnlyProjects : statusList"
            item-text="statusPL"
            item-value="statusEN"
            :label="onlyProjects ? 'Status projektu' : 'Status wniosku'"
            clearable
          ></v-autocomplete>
        </v-flex>
      </v-layout>
      <v-layout align-center justify-center row>
        <v-flex :class="onlyProjects ? 'xs2' : 'xs3'">
          <v-autocomplete
            class="ma-2"
            v-model="searchedFields.countryId"
            :items="countryList"
            item-text="name"
            item-value="id"
            :label="onlyProjects ? 'Kraj projektu' : 'Kraj wniosku'"
            clearable
          ></v-autocomplete>
        </v-flex>
        <v-flex xs2 v-if="onlyProjects">
          <v-text-field
            browser-autocomplete="off"
            class="ma-2"
            v-model="searchedFields.supervisorName"
            label="Nazwisko opiekuna"
            aria-label="agency project supervisor"
            for="all-projects-list-agency-project-supervisor"
            id="all-projects-list-agency-project-supervisor"
          ></v-text-field>
        </v-flex>
        <v-flex :class="onlyProjects ? 'xs6' : 'xs7'">
          <v-layout align-center justify-center>
            <v-btn @click="buildNewSearch" color="primary" dark class="ma-2"
              >Szukaj</v-btn
            >
            <v-btn @click="resetSearch" color="primary" dark class="ma-2"
              >Resetuj</v-btn
            >
            <v-btn @click="exportData" color="primary" dark class="ma-2"
              >Eksportuj</v-btn
            >
            <v-menu offset-y :disabled="!exportActive" v-if="onlyProjects">
              <template v-slot:activator="{ on }">
                <v-tooltip bottom :disabled="exportActive">
                  <template v-slot:activator="{ on: onTooltip }">
                    <div v-on="{ ...on, ...onTooltip }">
                      <v-btn color="primary" dark :disabled="!exportActive">
                        Eksport formularzy
                      </v-btn>
                    </div>
                  </template>
                  <span>{{ exportTooltip }}</span>
                </v-tooltip>
              </template>
              <v-list>
                <v-list v-for="(item, index) in exportMenu" :key="index">
                  <v-list-tile @click="openModal(item.type)">{{
                    item.label
                  }}</v-list-tile>
                </v-list>
              </v-list>
            </v-menu>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-data-table
        :headers="headers"
        :rows-per-page-items="[10, 20, 25]"
        :items="projects"
        :pagination.sync="pagination"
        :total-items="itemCount"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td>
            {{ props.item.agencyProjectCode }}
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  color="red"
                  left
                  style="margin-left: 5px"
                  v-if="props.item.status === 'ANNULLED' && onlyProjects"
                  >cancel</v-icon
                >
              </template>
              <div>
                <b>Projekt anulowany</b>
              </div>
              <span>{{ props.item.annulationCause }}</span>
            </v-tooltip>
          </td>
          <td>{{ props.item.name }}</td>
          <td v-show="!onlyMine && onlyProjects">
            {{
              formatMoneyWithCode(
                props.item.ministerDonation,
                props.item.currencyCode
              )
            }}
          </td>
          <td v-show="onlyMine || !onlyProjects">
            {{
              formatMoneyWithCode(
                props.item.requestedDonation,
                props.item.currencyCode
              )
            }}
          </td>
          <td>{{ props.item.agencyName }}</td>
          <td>{{ props.item.mainCountry }}</td>
          <td v-show="!onlyMine && onlyProjects">
            {{ props.item.supervisorName }}
          </td>
          <td>
            <v-tooltip bottom v-if="onlyProjects && !props.item.hideFromUser">
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-if="
                    roles.isAdministrator() || userDepartmentContest(props.item)
                  "
                  @click="showProjectPanel(props.item)"
                >
                  <v-icon v-on="on"> business </v-icon>
                </v-btn>
              </template>
              <span>Panel projektu</span>
            </v-tooltip>
            <v-tooltip
              bottom
              v-if="
                agencyProjectViewAvailable(props.item) &&
                !props.item.hideFromUser
              "
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  @click="
                    viewAgencyProject(
                      props.item.contestId,
                      props.item.agencyId,
                      props.item.id
                    )
                  "
                >
                  <v-icon v-on="on"> description </v-icon>
                </v-btn>
              </template>
              <span>Podgląd</span>
            </v-tooltip>
            <v-tooltip bottom v-if="onlyProjects && !props.item.hideFromUser">
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-if="
                    roles.isAdministrator() || userDepartmentContest(props.item)
                  "
                  @click="showProjectSummary(props.item)"
                >
                  <v-icon small v-on="on"> ballot </v-icon>
                </v-btn>
              </template>
              <span>Podsumowanie projektu</span>
            </v-tooltip>
            <v-tooltip
              bottom
              v-if="
                agencyProjectViewAvailable(props.item) &&
                props.item.canDownloadSignedReportFile
              "
            >
              <template v-slot:activator="{ on }">
                <v-btn icon @click="navigateToFinalReportSigned(props.item)">
                  <v-icon v-on="on">file_download</v-icon>
                </v-btn>
              </template>
              <span>Pobierz podpisane sprawozdanie</span>
            </v-tooltip>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <agency-project-export-modal ref="agencyProjectExportModal" />
    <agency-final-report-export-modal ref="agencyFinalReportExportModal" />
    <agency-monitoring-export-modal ref="agencyMonitoringExportModal" />
  </div>
</template>

<script>
import { Api } from "@/api";
import { AccreditationCountry } from "@/api/generated/AccreditationCountry";
import { Pagination } from "@/utils/PaginationUtils";
import { Agency } from "@/api/generated/Agency";
import { ExportUtils } from "@/utils/ExportUtils";
import { AgencyProject } from "@/api/generated/AgencyProject";
import AgencyFinalReportExportModal from "../agencyProject/components/AgencyFinalReportExportModal";
import AgencyMonitoringExportModal from "../agencyProject/components/AgencyMonitoringExportModal";
import AgencyProjectExportModal from "../agencyProject/components/AgencyProjectExportModal";
import { Numbers } from "@/utils/Numbers";
import { Filters } from "@/utils/Filters";
import { Files } from "@/utils/Files";

export default {
  name: "AllAgencyProjectsList",

  components: {
    AgencyProjectExportModal,
    AgencyMonitoringExportModal,
    AgencyFinalReportExportModal,
  },

  props: {
    onlyMine: {
      default: false
    },
    onlyProjects: {
      type: Boolean
    }
  },

  data() {
    return {
      headers: [
        { text: this.onlyProjects ? "Numer projektu" : "Numer wniosku", value: "projectCode", align: "left", sortable: true },
        { text: this.onlyProjects ? "Nazwa projektu" : "Nazwa wniosku", value: "name", align: "left", sortable: true },
        { text: "Kwota wnioskowana", value: "requestedDonation", sortable: false },
        { text: "Nazwa placówki", value: "agencyName", sortable: true },
        { text: "Kraj główny", value: "mainCountry", sortable: true },
        { text: "Akcje", sortable: false }
      ],
      itemCount: 0,
      pagination: {
        rowsPerPage: 25,
        sortBy: null
      },
      projects: [],
      countryList: [],
      agencyList: [],
      yearList: [],
      contestNameList: [],
      dataTable: { search: "" },
      legalFormList: [],
      exportActive: false,
      statusListOnlyProjects: [
        { statusPL: 'Realizowany', statusEN: 'APPROVED' },
        { statusPL: 'Projekt oczekuje na poprawki', statusEN: 'PROJECT_CHANGES_REQUESTED' },
        { statusPL: 'Zakończony', statusEN: 'FINISHED' },
        { statusPL: 'Anulowany', statusEN: 'ANNULLED' },
      ],
      statusList: [
        { statusPL: 'Wysłany', statusEN: 'SUBMITTED' },
        { statusPL: 'Oczekuje na poprawki', statusEN: 'AWAITING_CORRECTION' },
        { statusPL: 'Odrzucony', statusEN: 'REJECTED' },
        { statusPL: 'Realizowany', statusEN: 'APPROVED' },
        { statusPL: 'Projekt oczekuje na poprawki', statusEN: 'PROJECT_CHANGES_REQUESTED' },
        { statusPL: 'Zakończony', statusEN: 'FINISHED' },
        { statusPL: 'Anulowany', statusEN: 'ANNULLED' },
      ],
      searchedFields: Pagination.initSearchedFields([
        'countryId',
        'projectStatus',
        'projectCode',
        'agencyId',
        'contestName',
        'supervisorName'
      ]),
      exportMenu: [
        { label: "Eksport projektów", type: "PROJECT_EXPORT" },
        { label: "Eksport raportów z monitoringu", type: "MONITORING_REPORT_EXPORT" },
        { label: "Eksport sprawozdań końcowych", type: "FINAL_REPORT_EXPORT" },
      ],
    };
  },

  computed: {
    pages() {
      // paginacja nie została zainicjalizowana
      if (this.pagination.rowsPerPage === undefined) {
        return 0;
      }
      return Math.ceil(this.itemCount / this.pagination.rowsPerPage);
    },

    searchedProjects() {
      return this.projects.filter(project => project.contestName === this.searchedFields.contestName);
    },

    projectCodes() {
      return this.searchedProjects.map(project => project.agencyProjectCode);
    },

    searchedContestId() {
      let searchedContests = [...new Set(this.searchedProjects.map(project => project.contestId))];
      return searchedContests.length === 1 ? searchedContests[0] : null;
    },

    exportTooltip() {
      return this.searchedFields.contestName
        ? "Kliknij Szukaj"
        : "Wybierz nabór i kliknij Szukaj";
    },
  },

  created() {
    this.getCountryList();
    this.getAgencyList();
    this.getAllAgencyContestNames();
    if (!this.onlyMine && this.onlyProjects) {
      this.headers.splice(this.headers.length - 1, 0,
        { text: "Opiekun projektu", value: "supervisorName", sortable: false });

      const ministerDonationIdx = this.headers.findIndex(obj => obj.text === 'Kwota wnioskowana');
      this.headers.splice(ministerDonationIdx, 1,
        { text: "Kwota dofinansowania", value: "ministerDonation", align: "left", sortable: false },);
    }
  },

  mounted() {
    this.searchedFields = this.retrieveFilters(this.searchedFields);
    this.pagination = this.retrievePagination(this.pagination);
    this.buildNewSearch();
  },

  watch: {
    "pagination": {
      handler(pagination) {
        this.getItemList();
        this.paginationRef = pagination;
      },
      deep: true,
    },

    searchedFields: {
      handler() {
        this.exportActive = false;
      },
      deep: true,
    },
  },

  mixins: [Numbers, Filters, Files],

  methods: {
    async navigateToFinalReportSigned(item) {
      await this.downloadFileAsBlob(this, this.getAgencyProjectSignedProjectFile(item.id), item.signedReportFileName);
    },
    buildNewSearch() {
      this.dataTable.search = this.buildSearchCriteria();
      this.exportActive = !!this.searchedFields.contestName;
      this.getItemList();
    },

    exportData() {
      let search = this.dataTable.search;
      let sort = this.buildSort();
      let endpointMainPath = "all-agency-projects";
      let path = "/" + endpointMainPath
        + "/export?search=" + search
        + "&sort=".concat(sort);
      ExportUtils.sendExportRequest(path, this);
    },

    openProjectExportModal() {
      this.$refs.agencyProjectExportModal.openModal({ ...this.searchedFields }, this.searchedContestId, this.onlyProjects, 'ALL_AGENCY_PROJECTS');
    },

    openFinalReportExportModal() {
      this.$refs.agencyFinalReportExportModal.openModal({ ...this.searchedFields }, this.searchedContestId, this.onlyProjects, 'ALL_AGENCY_PROJECTS');
    },

    openMonitoringExportModal() {
      this.$refs.agencyMonitoringExportModal.openModal({ ...this.searchedFields }, this.searchedContestId, this.onlyProjects, 'ALL_AGENCY_PROJECTS');
    },

    openModal(type) {
      switch (type) {
        case "PROJECT_EXPORT":
          this.openProjectExportModal();
          break;
        case "FINAL_REPORT_EXPORT":
          this.openFinalReportExportModal();
          break;
        case "MONITORING_REPORT_EXPORT":
          this.openMonitoringExportModal();
          break;
      }
    },

    getItemList() {
      let sort = this.buildSort();
      this.dataTable.search = this.dataTable.search.concat('onlyProjects::').concat(this.onlyProjects.toString()).concat('$$');
      Api.get(this,
        "/all-agency-projects/list?search=" + this.dataTable.search
        + "&page=" + this.pagination.page
        + "&result=" + this.pagination.rowsPerPage
        + "&sort=".concat(sort), response => {
          this.projects = response.itemList;
          this.itemCount = response.itemCount;
        });
    },

    buildSearchCriteria() {
      return Pagination.buildSearchCriteria(this.searchedFields, false);
    },

    buildSort() {
      let order = this.pagination.descending === true ? "desc" : "asc";
      let columnName = this.pagination.sortBy;
      if (order && columnName) {
        return columnName.concat(" ").concat(order);
      } else {
        return "";
      }
    },

    resetSearch() {
      Pagination.resetSearch(this.searchedFields);
      this.dataTable.search = "";
      this.exportActive = false;
      this.getItemList();
    },

    getCountryList() {
      AccreditationCountry.get(this, successResponse => {
        this.countryList = successResponse;
      },
        errorResponse => {
          this.$messagesBus.$emit("error", "Nie udało się załadować kraje", errorResponse);
        });
    },

    getAgencyList() {
      Agency.getAll(this, successResponse => {
        this.agencyList = successResponse;
      },
        errorResponse => {
          this.$messagesBus.$emit("error", "Nie udało się załadować placówek", errorResponse);
        });
    },

    getAllAgencyContestNames() {
      AgencyProject.getAllContestNames(this, false, successResponse => {
        this.contestNameList = successResponse.sort();
      },
        errorResponse => {
          this.$messagesBus.$emit("error", "Nie udało się załadować nazw konkursów", errorResponse);
        });
    },

    userDepartmentContest(project) {
      return (this.roles.isLocalAdministrator() || this.roles.isDepartmentEmployee()) && project.contestFromUserDepartment;
    },

    showProjectPanel(project) {
      this.$router.push("/app/agency-contest/" + project.contestId + "/project-panel/" + project.id);
    },

    showProjectSummary(project) {
      this.$router.push("/app/agency-project/" + project.id + "/summary/");
    },

    agencyProjectViewAvailable(project) {
      if(this.onlyProjects){
        return this.roles.isAdministrator() ||
        ((this.roles.isLocalAdministrator() || this.roles.isDepartmentEmployee() || project.supervisor) && project.contestFromUserDepartment);
      }
      return this.roles.isAdministrator() ||
        ((this.roles.isLocalAdministrator() || (this.roles.isDepartmentEmployee() && project.agencyContestFinished) || project.supervisor) && project.contestFromUserDepartment);
    },

    viewAgencyProject(contestId, agencyId, agencyProjectId) {
      this.$router.openInNewTab("/view/agency-contest/" + contestId + "/project/" + agencyId + "/" + agencyProjectId);
    },
  },
};
</script>

<style scoped>
tr td:first-of-type {
  white-space: nowrap;
}
</style>
